import React, { useEffect, useState } from 'react';
import { Paragraph } from '../../basic/title';
import { LoginForm } from '../../basic/auth';
import { Btnone } from '../../basic/button';
import PaymentOptions from './PaymentOptions';
import { IoMdAdd } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { getAddress } from '../../../../redux/slices/address';
import { CheckoutbillingAddress, CheckoutshippingAddress } from '../../myaccount/address/DefultAddress';
import { CheckoutShipingaddress } from '../../myaccount/address';
import CheckoutBillingaddress from '../../myaccount/address/CheckoutBillingaddress';
import GuestAddressBilling from '../../myaccount/address/GuestAddressBilling';
import GuestAddressShipping from '../../myaccount/address/GuestAddressShipping';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { postcodorder } from '../../../../redux/slices/codorder';
import { resendVerificationPhone } from '../../../../redux/slices/loginRegister';

const AccordionExample = ({ cartData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [allAddressData, setAllAddressData] = useState([]);
  const [shipAddress, setShipAddress] = useState([]);
  const [billAddress, setBillingAddress] = useState([]);

  const [isOpen, setIsOpen] = useState(true);
  const [isShippingOpen, setIsShippingOpen] = useState(false);
  const [isBillingOpen, setIsBillingOpen] = useState(false);
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const [isNewBillingOpen, setIsNewBillingOpen] = useState(false);
  const [isNewShippingOpen, setIsNewShippingOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [resent, setResent] = useState(false);
  const [trigger, setTrigger] = useState(false);

  const accessToken = localStorage.getItem('accessToken') || null;
  const localUser = JSON.parse(localStorage.getItem('user')) || {};
  const userName = localUser?.name || null;
  const phoneVerifiedAt = localUser?.phone_verified_at || null;
  const customer_id = localUser?.id || null;

  const { allAddress } = useSelector(state => state.address);
  const { oneId } = useSelector(state => state.codorder);
  const isProfileIncomplete = !localUser?.email || !localUser?.contact;

  useEffect(() => {
    if (customer_id) dispatch(getAddress(customer_id));
  }, [dispatch, customer_id]);

  useEffect(() => {
    if (allAddress?.length > 0) {
      setAllAddressData(allAddress);
    }
  }, [allAddress]);

  useEffect(() => {
    if (allAddressData?.length > 0) {
      const filteredDataShipping = allAddressData.filter(address => address?.is_shipping);
      setShipAddress(filteredDataShipping);
      const filteredDataBilling = allAddressData.filter(address => address?.is_billing);
      setBillingAddress(filteredDataBilling);
    }
  }, [allAddressData]);

  const handleVerifyNow = async () => {
    const userId = localUser?.id;
    const phone = localUser?.contact;

    if (!userId || !phone) {
      toast.error("User ID or phone number missing.");
      return;
    }

    setLoading(true);

    try {
      await resendVerificationPhone(userId, phone, setLoading, setResent, toast);
      navigate("/verify-phone", {
        state: { user_id: userId, phone },
      });
    } catch (error) {
      toast.error("Failed to send verification code.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddNewbillingAddress = () => setIsNewBillingOpen(prev => !prev);
  const handleAddNewShippingAddress = () => setIsNewShippingOpen(prev => !prev);

  const handleAccordionToggle = setter => {
    setIsOpen(false);
    setIsBillingOpen(false);
    setIsShippingOpen(false);
    setIsPaymentOpen(false);
    setter(prev => !prev);
  };

  const handleShippingClick = () => {
    setTrigger(true);
    setIsShippingOpen(false);
    setIsBillingOpen(true);
  };

  const handleBillingClick = () => {
    setTrigger(true);
    setIsBillingOpen(false);
    setIsPaymentOpen(true);
  };

  const handlebackBillClick = () => {
    setIsShippingOpen(true);
    setIsBillingOpen(false);
    setIsNewShippingOpen(false);
  };

  const handlebackShipClick = () => {
    setIsOpen(true);
    setIsShippingOpen(false);
  };

  const handlebackPayClick = () => {
    setIsPaymentOpen(false);
    setIsBillingOpen(true);
    setIsNewBillingOpen(false);
  };

  const handleConfirmOrder = () => {
    const cartDataid = localStorage?.getItem('cart_id') || null;
    const cart_id = cartDataid !== null ? Number(cartDataid) : null;

    const selectedItems = cartData?.filter(item => item.selected);
    if (!selectedItems || selectedItems.length === 0) {
      toast.error("Please select at least one item to place the order.");
      return;
    }

    const formattedItems = selectedItems.map(item => {
      let price = parseFloat(item.price || 0);
      let discount_price = null;

      try {
        const variants = typeof item.selected_variants === 'string'
          ? JSON.parse(item.selected_variants)
          : item.selected_variants;

        for (const key in variants) {
          const variant = variants[key];
          if (variant?.id === item.variant_id) {
            price = parseFloat(variant.price || price);
            if (variant.hasOwnProperty('discount_price')) {
              discount_price = parseFloat(variant.discount_price);
            }
            break;
          }
        }
      } catch (err) {
        console.error("Failed to parse selected_variants", err);
      }

      return {
        ...item,
        price: price,
        discount: discount_price !== null ? discount_price : price,
      };
    });

    const cartItem = {
      ...(cart_id && { cart_id }),
      ...(customer_id && { customer_id }),
      items: formattedItems,
    };

    dispatch(postcodorder(cartItem, navigate, toast));
  };

  return (
    <>
      <div className="shadow-md rounded-lg">
        <div className="rounded-t-lg p-3 bg-gray-100">
          <div className="flex items-center justify-between border-b-2 pb-1 border-[#072320]">
            <h2 className="font-dm text-xl capitalize font-medium text-left text-[#072320]">
              {accessToken ? `Welcome back, ${userName}!` : 'Guest Checkout Or login'}
            </h2>
            <div className="flex items-center justify-center h-8 w-8 rounded-md bg-[#072320] cursor-pointer">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`h-6 text-white w-6 ${isOpen ? 'transform rotate-180' : ''}`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        {isOpen && (
          <div className="py-6 px-4">
            {accessToken ? (
              <div className="flex flex-col items-center w-full">
                <div className="py-4 px-4 bg-[#072320] rounded-md shadow-md w-full">
                  <Paragraph
                    color="white"
                    title={`Welcome back ${userName}, Ready to complete your grocery shopping?`}
                  />
                </div>

                {!phoneVerifiedAt && (
                  <div className="mb-4 mt-4 p-4 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 rounded w-full">
                    📱 Your phone number is **not verified**. Please verify it to continue checkout.

                    <div className="mt-2">
                      <button
                        className="px-4 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
                        onClick={handleVerifyNow}
                        disabled={loading}
                      >
                        {loading ? "Sending..." : "Verify Now"}
                      </button>
                    </div>
                  </div>
                )}

                {cartData?.some(item => item.selected) && (
                  <div className="flex flex-col items-start w-full pt-4">
                    <Btnone
                      title="Continue"
                      handleClick={() => {
                        if (!phoneVerifiedAt) {
                          toast.warning("📱 Please verify your phone number before proceeding to checkout.");
                          return;
                        }
                        handleAccordionToggle(setIsShippingOpen);
                      }}
                      bgColor="#00A762"
                    />
                  </div>
                )}
              </div>
            ) : (
              <div className="grid grid-cols-12 md:gap-8 gap-4">
                <div className="lg:col-span-6 col-span-12">
                  <h2 className="font-dm border-b-2 pb-1 border-[#072320] text-lg capitalize font-medium text-center text-[#072320]">
                    Guest Checkout
                  </h2>
                  <div className="my-8 py-4 px-4 bg-[#072320] rounded-md shadow-md">
                    <Paragraph
                      color="white"
                      title="Save time by skipping the account creation process. Just fill in your shipping and payment details, and you’re done"
                    />
                  </div>
                  <Btnone
                    title="continue as guest"
                    handleClick={() => handleAccordionToggle(setIsShippingOpen)}
                    bgColor="#00A762"
                    width="100%"
                  />
                </div>
                <div className="lg:col-span-6 col-span-12">
                  <h2 className="font-dm text-lg capitalize border-b-2 pb-1 border-[#072320] font-medium text-center text-[#072320]">
                    Have an account? Login
                  </h2>
                  <LoginForm handleClick={() => handleAccordionToggle(setIsShippingOpen)} />
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="shadow-md rounded-lg mt-8">
        <div className="rounded-t-lg p-3 bg-gray-100">
          <div className="flex items-center justify-between border-b-2 pb-1 border-[#072320]">
            <h2 className="font-dm text-xl capitalize font-medium text-left text-[#072320]">
              Shipping Address
            </h2>
            <div
              className="flex items-center justify-center h-8 w-8 rounded-md bg-[#072320] cursor-pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`h-6 text-white w-6 ${isShippingOpen ? 'transform rotate-180' : ''}`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        {isShippingOpen && (
          <>
            <div className="p-3">
              {accessToken ? (
                <>
                  {isNewShippingOpen || shipAddress.length === 0 ? (
                    <div className="shadow-md rounded-lg border-[#00A762] border-2 p-4 my-4">
                      <CheckoutShipingaddress
                        backCLick={() => handlebackShipClick()}
                        checkship={true}
                        handleClick={handleShippingClick}
                      />
                    </div>
                  ) : null}

                  {shipAddress.length > 0 && (
                    <>
                      <div
                        className="font-dm text-lg my-2 w-fit cursor-pointer capitalize flex items-center justify-end rounded-lg shadow-md border-[#00A762] border-[2px] px-3 py-1 font-medium text-left text-[#00A762]"
                        onClick={handleAddNewShippingAddress}
                      >
                        <IoMdAdd className="mr-2 text-2xl" /> Add New Address
                      </div>

                      <CheckoutshippingAddress
                        allAddressData={shipAddress}
                        handleClick={() => handleAccordionToggle(setIsBillingOpen)}
                        handlebackClick={() => handlebackShipClick()}
                      />
                    </>
                  )}
                </>
              ) : (
                <>
                  <div className="shadow-md rounded-lg border-[#00A762] border-2 p-4 my-4">
                    <GuestAddressShipping
                      backCLick={() => handlebackShipClick()}
                      handleClick={() => handleAccordionToggle(setIsBillingOpen)}
                    />
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>

      <div className="shadow-md rounded-lg mt-8">
        <div className="rounded-t-lg p-3 bg-gray-100">
          <div className="flex items-center justify-between border-b-2 pb-1 border-[#072320]">
            <h2 className="font-dm text-xl capitalize font-medium text-left text-[#072320]">
              Billing Address
            </h2>
            <div
              className="flex items-center justify-center h-8 w-8 rounded-md bg-[#072320] cursor-pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`h-6 text-white w-6 ${isBillingOpen ? 'transform rotate-180' : ''}`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        {isBillingOpen && (
          <>
            <div className="p-3">
              {accessToken ? (
                <>
                  {isNewBillingOpen || billAddress.length === 0 ? (
                    <div className="shadow-md rounded-lg border-[#00A762] border-2 p-4 my-4">
                      <CheckoutBillingaddress
                        backCLick={() => handlebackBillClick()}
                        checkbil={true}
                        handleClick={handleBillingClick}
                      />
                    </div>
                  ) : null}

                  {billAddress.length > 0 && (
                    <>
                      <div
                        className="font-dm text-lg my-2 w-fit cursor-pointer capitalize flex items-center justify-end rounded-lg shadow-md border-[#00A762] border-[2px] px-3 py-1 font-medium text-left text-[#00A762]"
                        onClick={handleAddNewbillingAddress}
                      >
                        <IoMdAdd className="mr-2 text-2xl" /> Add New Address
                      </div>

                      <CheckoutbillingAddress
                        allAddressData={billAddress}
                        handleClick={() => handleAccordionToggle(setIsPaymentOpen)}
                        handlebackClick={() => handlebackBillClick()}
                      />
                    </>
                  )}
                </>
              ) : (
                <>
                  <div className="shadow-md rounded-lg border-[#00A762] border-2 p-4 my-4">
                    <GuestAddressBilling
                      backCLick={() => handlebackBillClick()}
                      handleClick={() => handleAccordionToggle(setIsPaymentOpen)} />
                  </div>


                </>
              )}
            </div>
          </>
        )}
      </div>

      <div className="shadow-md rounded-lg mt-8">
        <div className="rounded-t-lg p-3 bg-gray-100">
          <div className="flex items-center justify-between border-b-2 pb-1 border-[#072320]">
            <h2 className="font-dm text-xl capitalize font-medium text-left text-[#072320]">
              Payment Option
            </h2>
            <div
              className="flex items-center justify-center h-8 w-8 rounded-md bg-[#072320] cursor-pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`h-6 text-white w-6 ${isPaymentOpen ? 'transform rotate-180' : ''}`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>
        {isPaymentOpen && (
          <>
            <PaymentOptions onConfirmOrder={handleConfirmOrder} backCLick={handlebackPayClick} cartDataitem={cartData} />
          </>
        )}
      </div>
    </>
  );
};

export default AccordionExample;